define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/form/Widget"
], function(declare,lang,Widget) {

	return declare(Widget, {
		// Object: map of attributes to expressions indicating if should be hidden
		_hideExpressions: {
			//If Style is selected, StyleType should be initialized from the Style.ProductType
			ProductStyleType: "validValue('ProductStyle')"
		}
	});
});